import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
    Loading, Error, useGetOne, useUpdate, useNotify,
} from 'react-admin';

import Form from './edit-attachment-form';

const EditAttachment = (props) => {
    const { attachmentId, onUpdated, onCancel, hideThumbnail } = props;

    const { data, isLoading, error } = useGetOne('attachments', { id: attachmentId });
    const [update, { isPending: updating }] = useUpdate();
    const notify = useNotify();

    const handleSubmit = useCallback((values) => {
        update(
            'attachments',
            { id: attachmentId, data: values },
            {
                onSuccess(data) {
                    onUpdated(data);
                },
                onError(error) {
                    notify(error.message, { type: 'error' });
                },
            },
        );
    }, [update, notify, onUpdated, attachmentId]);

    if (isLoading) return <Loading />;
    if (error) return <Error error={error} errorInfo={{ componentStack: null }} />;
    if (!data) return null;

    return (
        <Form
            attachment={data}
            updating={updating}
            hideThumbnail={hideThumbnail}
            onCancel={onCancel}
            onSubmit={handleSubmit}
        />
    );
};

EditAttachment.propTypes = {
    attachmentId: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onUpdated: PropTypes.func.isRequired,
    hideThumbnail: PropTypes.bool,
};

export default EditAttachment;
